import { Injectable } from "@angular/core";
import { FormService } from "./form.service";
import { Client, FileParameter, MediaTypeEnum } from "src/domain/client";

@Injectable({
  providedIn: "root"
})
export class FileService {
  public fileIds: string[] = [];
  private client = new Client();
  constructor(private formService: FormService) {}

  async uploadFile(file: FileParameter): Promise<string> {
    const fileId = await this.client.apiV2MediaPost(
      MediaTypeEnum.Image,
      this.formService.carInfoResponse.chassiNumber,
      file
    );
    this.fileIds.push(fileId);
    return fileId;
  }

  clearFile(fileId: string): void {
    if (!fileId) return;
    const index = this.fileIds.indexOf(fileId);
    if (index > -1) this.fileIds.splice(index, 1);
  }
}
